export default __webpack_public_path__ + "static/media/trr-event-paint.22a7e7af.png";